import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useContext } from 'react';
export function useShouldRenderAdArea(adSafety) {
    const { adsEnabled  } = useContext(SessionContext);
    const isNsfgFallback = useFlag('ads_dealer_nsfg');
    if (isNsfgFallback) {
        return adsEnabled;
    }
    return adsEnabled && adSafety !== 'off';
}
